import React, { useEffect, useRef } from 'react';
import './App.css';

function App() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMouseMove = (e: MouseEvent) => {
      const rect = container.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Calculate direction from center to cursor
      const deltaX = e.clientX - centerX;
      const deltaY = e.clientY - centerY;
      
      // Normalize the direction
      const length = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      const normalizedX = deltaX / length;
      const normalizedY = deltaY / length;
      
      // Set CSS custom properties for escape direction
      document.documentElement.style.setProperty('--escape-x', `${-normalizedX * 40}px`);
      document.documentElement.style.setProperty('--escape-y', `${-normalizedY * 40}px`);
    };

    container.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="App">
      <main className="wip-container" ref={containerRef}>
        {/* Background decorative elements removed */}
        
        {/* Creative background shapes */}
        <div className="creative-shapes" aria-hidden="true">
          <div className="shape shape-1" role="presentation"></div>
          <div className="shape shape-2" role="presentation"></div>
          <div className="shape shape-3" role="presentation"></div>
          <div className="shape shape-4" role="presentation"></div>
        </div>
        
        {/* Header section with logo */}
        <header className="logo-section">
          <img src="/new.svg" alt="GoLab Logo - Innowacyjne rozwiązania technologiczne" className="golab-logo" />
        </header>
        
        {/* Main content section */}
        <section className="content-wrapper">
          <h1 className="main-title">
            Strona w trakcie realizacji
          </h1>
          
          <p className="subtitle">
            Pracujemy nad czymś wyjątkowym
          </p>
          
          {/* Creative middle section - completely redesigned */}
          <div className="creative-middle-section" aria-hidden="true">
            {/* DNA-like structure */}
            <div className="dna-structure" role="presentation">
              <div className="dna-helix">
                <div className="dna-strand strand-1"></div>
                <div className="dna-strand strand-2"></div>
                <div className="dna-connectors">
                  {[...Array(12)].map((_, i) => (
                    <div key={i} className="dna-connector" style={{ animationDelay: `${i * 0.2}s` }}></div>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Particle system */}
            <div className="particle-system" role="presentation">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i} 
                  className="particle" 
                  style={{ 
                    animationDelay: `${i * 0.3}s`,
                    left: `${Math.random() * 100}%`,
                    top: `${Math.random() * 100}%`
                  }}
                ></div>
              ))}
            </div>
            
            {/* Abstract geometric art */}
            <div className="geometric-art" role="presentation">
              <div className="art-piece piece-1"></div>
              <div className="art-piece piece-2"></div>
              <div className="art-piece piece-3"></div>
              <div className="art-piece piece-4"></div>
              <div className="art-piece piece-5"></div>
            </div>
            
            {/* Energy waves */}
            <div className="energy-waves" role="presentation">
              <div className="energy-wave wave-1"></div>
              <div className="energy-wave wave-2"></div>
              <div className="energy-wave wave-3"></div>
            </div>
            
            {/* Floating orbs */}
            <div className="floating-orbs" role="presentation">
              <div className="orb orb-1"></div>
              <div className="orb orb-2"></div>
              <div className="orb orb-3"></div>
            </div>
          </div>
        </section>
        
        {/* Footer with contact information */}
        <footer className="footer">
          <div className="footer-content">
            <div className="footer-info">
              <span className="footer-email">kontakt@go-lab.com.pl</span>
            </div>
          </div>
        </footer>
        
        {/* Floating elements */}
        <div className="floating-element floating-element-1" aria-hidden="true" role="presentation"></div>
        <div className="floating-element floating-element-2" aria-hidden="true" role="presentation"></div>
        <div className="floating-element floating-element-3" aria-hidden="true" role="presentation"></div>
      </main>
    </div>
  );
}

export default App;
